import script from "./comments_products.vue?vue&type=script&setup=true&lang=js"
export * from "./comments_products.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__